import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "33",
  fill: "none",
  viewBox: "0 0 32 33"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16 27.167c5.891 0 10.667-4.776 10.667-10.667S21.89 5.833 16 5.833 5.333 10.61 5.333 16.5 10.109 27.167 16 27.167m0 2.666c7.364 0 13.333-5.97 13.333-13.333S23.363 3.167 16 3.167 2.667 9.136 2.667 16.5 8.637 29.833 16 29.833",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16 9.834a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666m0 5.333c-.736 0-1.333.597-1.333 1.333v5.334a1.333 1.333 0 1 0 2.666 0V16.5c0-.736-.597-1.333-1.333-1.333",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }